const apiClient = require('@/api/client.js')

export default {

  send(contact, callback){

    if (!contact.first_name){
      return callback(new Error('Please enter your first name'))
    }

    if (!contact.last_name){
      return callback(new Error('Please enter your last name'))
    }
    
    if (!contact.email){
      return callback(new Error('Please enter a valid email address'))
    }

    if (!contact.phone){
      return callback(new Error('Please enter a valid phone number'))
    }

    if (!contact.state){
      return callback(new Error('Please select state'))
    }

    if (!contact.number_of_locations){
      return callback(new Error('Please enter a valid amount of locations'))
    }

    if (!contact.message){
      return callback(new Error('Please enter a message'))
    }

    // This is LD website API key
    return apiClient.makeRequest('POST', '/contact', contact, {'x-api-key': '899deca0ca2e6763d8068c756a8f575d'}, callback);

  }

}



// WEBPACK FOOTER //
// ./src/components/contact/service.js